import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    calLink: String,
    origin: { type: String, default: "https://app.cal.eu" }
  };

  connect() {
    this.currentTheme = null;
    this.initializeCal();
    this.startThemeObserver();
  }

  disconnect() {
    this.stopThemeObserver();
    this.element.innerHTML = "";
  }

  startThemeObserver() {
    // Watch for dark class changes on html element
    this.themeObserver = new MutationObserver(() => {
      const newTheme = document.documentElement.classList.contains("dark") ? "dark" : "light";
      if (this.currentTheme && this.currentTheme !== newTheme) {
        this.currentTheme = newTheme;
        this.reinitializeCal();
      }
    });

    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  stopThemeObserver() {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  }

  initializeCal() {
    if (!window.Cal) {
      this.loadCalScript().then(() => this.setupCalEmbed());
    } else {
      this.setupCalEmbed();
    }
  }

  reinitializeCal() {
    this.element.innerHTML = "";
    this.setupCalEmbed();
  }

  loadCalScript() {
    return new Promise((resolve) => {
      (function (C, A, L) {
        const p = function (a, ar) { a.q.push(ar); };
        const d = C.document;
        C.Cal = C.Cal || function () {
          const cal = C.Cal;
          const ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () { p(api, arguments); };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === "string") {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ["initNamespace", namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
      })(window, "https://app.cal.eu/embed/embed.js", "init");

      const checkCal = setInterval(() => {
        if (window.Cal && window.Cal.loaded) {
          clearInterval(checkCal);
          resolve();
        }
      }, 50);

      setTimeout(() => {
        clearInterval(checkCal);
        resolve();
      }, 5000);
    });
  }

  setupCalEmbed() {
    this.namespace = `cal-${Date.now()}`;
    this.currentTheme = document.documentElement.classList.contains("dark") ? "dark" : "light";

    window.Cal("init", this.namespace, { origin: this.originValue });

    window.Cal.ns[this.namespace]("inline", {
      elementOrSelector: this.element,
      config: { layout: "month_view", theme: this.currentTheme },
      calLink: this.calLinkValue,
    });

    window.Cal.ns[this.namespace]("ui", {
      cssVarsPerTheme: {
        light: { "cal-brand": "#00994d" },
        dark: { "cal-brand": "#00ff88" }
      },
      hideEventTypeDetails: false,
      layout: "month_view"
    });
  }
}
